import {
    createCheckboxClickHandler,
    createVerifyDeterminationCallback,
    selectAll
} from './SelectableCheckboxes';
import {toggleActionBar} from './ActionBar';

const SHOW_SELECTABLE_ROW_ANIMATION_THRESHOLD_MS = 100;
const LONG_TOUCH_THRESHOLD_MS = 800;

let timeoutId = null;

const overwriteContainingRowStatus = (checkbox, checked) => {
    const parentRow = checkbox.closest('tr');
    const rowIcon = parentRow.querySelector('i');

    parentRow.classList.toggle('checked', checked);

    if (rowIcon) {
        rowIcon.classList.toggle('fa-chevron-right', !checked);
        rowIcon.classList.toggle('fa-check', checked);
    }
};

const loopCheckedRowStatus = checkboxes => {
    checkboxes.forEach(checkbox => {
        overwriteContainingRowStatus(checkbox, checkbox.checked);
    });
};

const SelectableRow = rowElement => {
    const checkbox = rowElement.querySelector('input[type=checkbox]');

    return {
        toggle: () => checkbox.checked = !checkbox.checked,
        isPending: () => rowElement.classList.add('pending-selection'),
        isNotPending: () => rowElement.classList.remove('pending-selection'),
    };
};

const Table = tableElement => {
    const checkboxes = Array.from(tableElement.querySelectorAll('tbody input[type=checkbox]'));
    const headerCheckbox = tableElement.querySelector('thead input[type=checkbox]');

    const verifyDeterminationCallback = () => {
        createVerifyDeterminationCallback(checkboxes, headerCheckbox)();
        loopCheckedRowStatus(checkboxes);
        toggleActionBar(checkboxes);
    };

    const startRowSelection = e => {
        if (e.target.closest('input, button, a, select, textarea')) {
            return;
        }

        const selectableRow = SelectableRow(e.target.closest('tr'));

        const stopRowSelection = () => {
            clearTimeout(timeoutId);
            selectableRow.isNotPending();
            tableElement.removeEventListener('touchmove', stopRowSelection);
            tableElement.removeEventListener('mousemove', stopRowSelection);
            tableElement.removeEventListener('touchcancel', stopRowSelection);
            tableElement.removeEventListener('touchend', stopRowSelection);
            tableElement.removeEventListener('mouseup', stopRowSelection);
        };

        tableElement.addEventListener('touchmove', stopRowSelection);
        tableElement.addEventListener('mousemove', stopRowSelection);
        tableElement.addEventListener('touchcancel', stopRowSelection);
        tableElement.addEventListener('touchend', stopRowSelection);
        tableElement.addEventListener('mouseup', stopRowSelection);

        const startAnimation = () => {
            selectableRow.isPending();

            const toggleRow = () => {
                selectableRow.toggle();
                verifyDeterminationCallback();
                stopRowSelection();
            };

            timeoutId = setTimeout(
                toggleRow,
                LONG_TOUCH_THRESHOLD_MS - SHOW_SELECTABLE_ROW_ANIMATION_THRESHOLD_MS,
            );
        };

        timeoutId = setTimeout(startAnimation, SHOW_SELECTABLE_ROW_ANIMATION_THRESHOLD_MS);
    };

    return {
        registerListeners: () => {
            headerCheckbox.addEventListener('click', event => {
                selectAll(checkboxes, event.target.checked);
                checkboxes.forEach(checkbox => {
                    overwriteContainingRowStatus(checkbox, event.target.checked);
                });
                toggleActionBar(checkboxes);
            });
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('click', createCheckboxClickHandler(checkbox, verifyDeterminationCallback));
            });
            tableElement.addEventListener('touchstart', startRowSelection);
            tableElement.addEventListener('mousedown', startRowSelection);
        },
    };
};

export const initTableSelection = tableElement => {
    const table = Table(tableElement);
    table.registerListeners();
};
